module.exports = __webpack_public_path__ + "img/ACCOUNTING.0ba008a9.svg";